import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './modules/user'

Vue.use(Vuex)

const state = {
  loadingCount: 0,
  disabledLoading: false,
  itemsPerPage: [ 15, 25, 50, {'text': 'Todos', 'value': -1} ]
}

const actions = {
  decrementLoading ({ commit }) {
    commit('decrementLoading')
  },
  incrementLoading ({ commit }) {
    commit('incrementLoading')
  },
  setDisabledLoading ({ commit }, value) {
    commit('setDisabledLoading', value)
  }
}

const mutations = {
  incrementLoading (state) {
    state.loadingCount++
  },
  decrementLoading (state) {
    if (state.loadingCount > 0) {
      state.loadingCount--
    }
  },
  setDisabledLoading (state, value) {
    state.disabledLoading = value
  }
}

const getters = {
  loading: state => {
    if (state.disabledLoading === true) return false
    return state.loadingCount !== 0
  },
  itemsPerPage: state => {
    return state.itemsPerPage
  }
}

export default new Vuex.Store({
  plugins: [
    createPersistedState({ storage: window.localStorage, key: 'store', paths: ['user'] })
  ],
  state,
  actions,
  mutations,
  getters,
  modules: {
    user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js